/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { t } from 'g3w-i18n';

  const __vue_script__ = {
    name: "action",
    data() {
      return {
        show: true
      }
    },
    props: {
      featureIndex: {
        type: Number
      },
      feature: {
        type: Object
      },
      layer: {
        type: Object
      },
      trigger: {
        type: Function
      },
      action: {
        type: Object,
        required: true
      },
    },
    methods: {
      async clickAction(action, layer, feature, featureIndex, event) {
        await this.trigger(action, layer, feature, featureIndex);
        if (action.hint_change) {
          const element = $(event.target).parent();
          const originalDataTitle = element.attr('data-original-title');
          element.attr('data-original-title', t(action.hint_change.hint));
          element.tooltip('show');
          setTimeout(() => {
            element.attr('data-original-title', originalDataTitle);
            element.tooltip('show');
          }, action.hint_change.duration || 600)
        }
        this.$emit('action-clicked', action)
      }
    },
    async created() {
      if (this.action.init) {
        this.action.init({ layer: this.layer, feature: this.feature, index: this.featureIndex, action: this.action });
      }
      if (typeof this.action.condition === 'function') {
        const show = this.action.condition({ layer: this.layer, feature: this.feature });
        this.show = show instanceof Promise ? await show: show;
      }
    },
    beforeDestroy() {
      if (typeof this.action.clear === 'function') {
        this.action.clear({ action: this.action, layer: this.layer, feature: this.feature });
      }
    }
  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show && (undefined === (_vm.action.state || {}).show ? _vm.show : _vm.action.state.show))?_c('span',{directives:[{name:"download",rawName:"v-download",value:(_vm.action.download),expression:"action.download"},{name:"disabled",rawName:"v-disabled",value:(!!(_vm.action.state || {}).disabled),expression:"!!(action.state || {}).disabled"},{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:(_vm.action.hint),expression:"action.hint",arg:"top",modifiers:{"create":true}}],staticClass:"action-button",class:{'toggled': (_vm.action.state || {}).toggled && _vm.action.state.toggled[_vm.featureIndex] },on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();},"click":function($event){$event.stopPropagation();return _vm.clickAction(_vm.action, _vm.layer, _vm.feature, _vm.featureIndex, $event)}}},[_c('span',{class:("action-button-icon " + (_vm.action.class)),staticStyle:{"padding":"2px"},style:(_vm.action.style)})]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QueryResultsAction.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__